module.exports = __webpack_public_path__ + "img/tal.818030d7.png";